const CustomProductsConfigurations = {
    pennant: {
        alignment: {
            padding: "55px 70px 136px 130px",
        },
        text: {
            label: "Custom Text",
            lines: 1,
            maxLength: 16,
            limitReached(text) {
                return text.length === this.maxLength;
            },
            styles: {
                options: [{
                        key: "Jersey",
                        value: "VARSITY",
                        fontSize: 20,
                        letterSpacing: 1,
                        specialFont: "Jersey Special",
                        noDesignIcon: {
                            textScaling: 1.2,
                            marginScaling: 1.2,
                        },
                    },
                    // {
                    //     key: "Jersey 69",
                    //     value: "VARSITY",
                    //     fontSize: 20,
                    //     letterSpacing: 1,
                    //     noDesignIcon: {
                    //         textScaling: 1.2,
                    //         marginScaling: 1.2,
                    //     },
                    // },
                    // {
                    //   key: "Growler Script",
                    //   value: "Script",
                    //   fontSize: 30,
                    //   lineHeight: 0.1,
                    //   paddingBottom: 30,
                    //   bottom: 5,
                    //   noDesignIcon: {
                    //     textScaling: 1.25,
                    //     marginScaling: 1.5,
                    //   },
                    // },
                    // {
                    //   key: "Gloucester MT Extra Condensed",
                    //   value: "CLASSIC",
                    //   fontSize: 35,
                    //   noDesignIcon: {
                    //     textScaling: 1.2,
                    //     marginScaling: 1.6,
                    //   },
                    // },
                    // {
                    //   key: "Ultramagnetic",
                    //   value: "ROUNDED",
                    //   fontSize: 27,
                    //   noDesignIcon: {
                    //     textScaling: 1.25,
                    //     marginScaling: 1.6,
                    //   },
                    // },
                    // {
                    //   key: "Soap",
                    //   value: "BUBBLE",
                    //   fontSize: 18,
                    //   noDesignIcon: {
                    //     textScaling: 1.2,
                    //     marginScaling: 1.25,
                    //   },
                    // },
                    // {
                    //   key: "ALAMO OP EDITED",
                    //   value: "Alamo",
                    //   fontSize: 18,
                    //   noDesignIcon: {
                    //     textScaling: 1.125,
                    //     marginScaling: 1.125,
                    //   },
                    // },
                ],
            },
            scaling: {
                "Jersey": {
                    1: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 44,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 92,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 86,
                        marginBottom: 36,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 32,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 77,
                        marginBottom: 28,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 69,
                        marginBottom: 15,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 58,
                        marginBottom: 4,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: 0,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 46,
                        marginBottom: -6,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 45,
                        marginBottom: -8,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 44,
                        marginBottom: -8,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -12,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 42,
                        marginBottom: -10,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -10,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 38,
                        marginBottom: -16,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 36,
                        marginBottom: -20,
                    },
                },
                "Jersey 69": {
                    1: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 35,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 12,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 0,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 55,
                        marginBottom: -5,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 49,
                        marginBottom: -10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 45,
                        marginBottom: -15,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 41,
                        marginBottom: -20,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 37,
                        marginBottom: -25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 35,
                        marginBottom: -25,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 32,
                        marginBottom: -35,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -35,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 28,
                        marginBottom: -35,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 26,
                        marginBottom: -35,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 25,
                        marginBottom: -35,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -35,
                    },
                },
                "Growler Script": {
                    1: {
                        lineHeight: 1,
                        fontSize: 120,
                        marginBottom: 105,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 85,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 95,
                        marginBottom: 75,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 92,
                        marginBottom: 70,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 83,
                        marginBottom: 55,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 75,
                        marginBottom: 48,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 35,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 30,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 55,
                        marginBottom: 25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: 20,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 49,
                        marginBottom: 15,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 46,
                        marginBottom: 12,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: 10,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: 8,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 37,
                        marginBottom: 2,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 34,
                        marginBottom: -5,
                    },
                },
                "ALAMO OP EDITED": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -22,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 38,
                        marginBottom: -23,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 35,
                        marginBottom: -25,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 33,
                        marginBottom: -27,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -30,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 29,
                        marginBottom: -31,
                    },
                },
                "Club Sandwich": {
                    1: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 25,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 82,
                        marginBottom: 20,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 75,
                        marginBottom: 15,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: 2,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: -8,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -15,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -20,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 36,
                        marginBottom: -25,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 32,
                        marginBottom: -25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -26,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -26,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 29,
                        marginBottom: -27,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 27,
                        marginBottom: -28,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 25,
                        marginBottom: -30,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -32,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 22,
                        marginBottom: -35,
                    },
                },
                "Cooprblk": {
                    1: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 25,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 82,
                        marginBottom: 20,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 75,
                        marginBottom: 15,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: 2,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: -8,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -15,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -20,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 36,
                        marginBottom: -25,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 32,
                        marginBottom: -25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -26,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -26,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 29,
                        marginBottom: -27,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 27,
                        marginBottom: -28,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 25,
                        marginBottom: -30,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -32,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 22,
                        marginBottom: -35,
                    },
                },
                "Double Porter 1": {
                    1: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 25,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 82,
                        marginBottom: 20,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 75,
                        marginBottom: 15,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: 2,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: -8,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -15,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -20,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 36,
                        marginBottom: -25,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 32,
                        marginBottom: -25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -26,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -26,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 29,
                        marginBottom: -27,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 27,
                        marginBottom: -28,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 25,
                        marginBottom: -30,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -32,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 22,
                        marginBottom: -35,
                    },
                },
                "Gloucester MT Extra Condensed": {
                    1: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 35,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 17,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 72,
                        marginBottom: 10,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 64,
                        marginBottom: 5,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 56,
                        marginBottom: 0,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 50,
                        marginBottom: -5,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 46,
                        marginBottom: -10,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 42,
                        marginBottom: -15,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 39,
                        marginBottom: -20,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 35,
                        marginBottom: -25,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 33,
                        marginBottom: -25,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -30,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -30,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 28,
                        marginBottom: -33,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 26,
                        marginBottom: -35,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -35,
                    },
                },
                Ultramagnetic: {
                    1: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 26,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 75,
                        marginBottom: 17,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: 7.25,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 50,
                        marginBottom: 0,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 47,
                        marginBottom: -5,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 40,
                        marginBottom: -10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 37,
                        marginBottom: -15,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 34,
                        marginBottom: -20,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 31,
                        marginBottom: -25,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 28,
                        marginBottom: -30,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 26,
                        marginBottom: -30,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -30,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 22,
                        marginBottom: -35,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 21,
                        marginBottom: -35,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 20,
                        marginBottom: -38,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 19,
                        marginBottom: -40,
                    },
                },
                Soap: {
                    1: {
                        lineHeight: 1,
                        fontSize: 85,
                        marginBottom: 16,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 13,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 45,
                        marginBottom: -12,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 38,
                        marginBottom: -17,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 33,
                        marginBottom: -25,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 30,
                        marginBottom: -28,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 27,
                        marginBottom: -32,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 24,
                        marginBottom: -35,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 22,
                        marginBottom: -38,
                    },
                    11: {
                        lineHeight: 1,
                        fontSize: 20,
                        marginBottom: -41,
                    },
                    12: {
                        lineHeight: 1,
                        fontSize: 19,
                        marginBottom: -44,
                    },
                    13: {
                        lineHeight: 1,
                        fontSize: 17,
                        marginBottom: -47,
                    },
                    14: {
                        lineHeight: 1,
                        fontSize: 16,
                        marginBottom: -47,
                    },
                    15: {
                        lineHeight: 1,
                        fontSize: 15,
                        marginBottom: -48,
                    },
                    16: {
                        lineHeight: 1,
                        fontSize: 14,
                        marginBottom: -48,
                    },
                },
            },
        },
        graphics: {
            label: "Graphic",
            options: [{
                    key: "",
                    value: "None",
                },
                {
                    key: "cheering_glasses",
                    value: "Cheering Glasses",
                },
                {
                    key: "cupid",
                    value: "Cupid",
                },
                {
                    key: "disco_ball",
                    value: "Disco Ball",
                },
                {
                    key: "rose",
                    value: "Rose",
                },
                {
                    key: "teddy_bear",
                    value: "Teddy Bear",
                },
                {
                    key: "love_letter",
                    value: "Love Letter",
                },
                {
                    key: "buffalo",
                    value: "Buffalo",
                },
                {
                    key: "baseball",
                    value: "Baseball",
                },
                {
                    key: "cactus",
                    value: "Cactus",
                },
                {
                    key: "camper",
                    value: "Camper",
                },
                {
                    key: "cheer_leader",
                    value: "Cheer Leader",
                },
                {
                    key: "dove",
                    value: "Dove",
                },
                {
                    key: "football",
                    value: "Football",
                },
                {
                    key: "horse",
                    value: "Horse",
                },
                {
                    key: "ice_skates",
                    value: "Ice Skates",
                },
                {
                    key: "mushroom",
                    value: "Mushroom",
                },
                {
                    key: "jeep",
                    value: "Jeep",
                },
                {
                    key: "lighthouse",
                    value: "Lighthouse",
                },
                {
                    key: "moose",
                    value: "Elk",
                },
                {
                    key: "mountain_man",
                    value: "Mountain Man",
                },
                {
                    key: "palm_tree",
                    value: "Palm Tree",
                },
                {
                    key: "panther",
                    value: "Panther",
                },
                {
                    key: "peace_sign",
                    value: "Peace Sign",
                },
                {
                    key: "pinky_swear",
                    value: "Pinky Swear",
                },
                {
                    key: "race_car",
                    value: "Race Car",
                },
                {
                    key: "rings",
                    value: "Rings",
                },
                {
                    key: "roller_skates",
                    value: "Roller Skates",
                },
                {
                    key: "scorpion",
                    value: "Scorpion",
                },
                {
                    key: "spider",
                    value: "Spider",
                },
                {
                    key: "skulls",
                    value: "Skulls",
                },
                {
                    key: "tent",
                    value: "Tent",
                },
                {
                    key: "torch",
                    value: "Torch",
                    shrink: true,
                },
                {
                    key: "bpride",
                    value: "Buffalo Pride",
                },
                {
                    key: "transpride",
                    value: "Trans Pride",
                },
                {
                    key: "thebird",
                    value: "The Bird",
                },
                {
                    key: "lesbianpride",
                    value: "Lesbian Pride",
                },
                {
                    key: "jockstrap",
                    value: "Jockstrap",
                },
                {
                    key: "heartburst",
                    value: "Heart Burst",
                },
                {
                    key: "gaypride",
                    value: "Gay Pride",
                },
                {
                    key: "carabiner",
                    value: "Carabiner",
                }
            ],
            resolver: (key) => `/customizer/icons/${key}.svg`,
        },
        body: {
            label: "Body Color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "kelly green",
                    value: "#105c37",
                },
                // {
                //     key: "cream",
                //     value: "#f1e7b2",
                // },
                // {
                //     key: "sand",
                //     value: "#F1DAB2",
                // },
                {
                    key: "red",
                    value: "#BF1329",
                },
                {
                    key: "navy",
                    value: "#121E39",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "white",
                    value: "#FFFFFF",
                },
                {
                    key: "columbia",
                    value: "#528cb2",
                },
                // {
                //     key: "forest",
                //     value: "#224131",
                // },
                {
                    key: "light purple",
                    value: "#8c689c",
                },
                {
                    key: "orange",
                    value: "#d96000",
                },
            ],
            resolver: (key) => `/customizer/custom-pennant/body/${key}.png`,
        },
        bandColor: {
            label: "Band and Ties",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#e4d3b9",
                // },
                
            ],
            resolver: (key) => `/customizer/custom-pennant/border/${key}.png`,
        },
        printColor: {
            label: "Print Color",
            options: [{
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#F1DAB2",
                // },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
            ],
            resolver: (key) => {
                switch (key) {
                    case "black":
                        return "#000000";
                    case "cream":
                        return "#f1e7b2";
                    case "sand":
                        return "#F1DAB2";
                    case "white":
                        return "#FFFFFF";
                    case "gold":
                        return "#FB9B00";
                    case "pink":
                        return "#EEB2CA";
                    case "red":
                        return "#BF1329";
                    default:
                        break;
                }
            },
        },
    },
    "4-sided-camp-flag": {
        text: {
            label: "Custom Text",
            lines: 3,
            maxLength: 10,
            limitReached(text) {
                const lines = text.split("\n");
                return lines.length === this.lines && lines.every((line) => line.length === this.maxLength);
            },
            styles: {
                options: [{
                        key: "Jersey",
                        value: "VARSITY",
                        fontSize: 20,
                        letterSpacing: 1,
                        specialFont: "Jersey Special",
                    },
                    // {
                    //     key: "Jersey 69",
                    //     value: "VARSITY",
                    //     fontSize: 20,
                    //     letterSpacing: 1,
                    // },
                    // {
                    //     key: "Growler Script",
                    //     value: "Script",
                    //     fontSize: 30,
                    //     lineHeight: 0.1,
                    //     paddingBottom: 30,
                    //     bottom: 5,

                    //     // marginBottom: -20,
                    // },
                    // {
                    //     key: "Gloucester MT Extra Condensed",
                    //     value: "CLASSIC",
                    //     fontSize: 35,
                    // },
                    // {
                    //     key: "Ultramagnetic",
                    //     value: "ROUNDED",
                    //     fontSize: 27,
                    // },
                    // {
                    //     key: "Soap",
                    //     value: "BUBBLE",
                    //     fontSize: 18,
                    // },
                    // {
                    //     key: "ALAMO OP EDITED",
                    //     value: "Alamo",
                    //     fontSize: 18,
                    // },
                ],
            },
            scaling: {
                "Growler Script": {
                    1: {
                        fontSize: 130,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    2: {
                        fontSize: 130,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    3: {
                        fontSize: 130,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    4: {
                        fontSize: 130,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    5: {
                        fontSize: 125,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    6: {
                        fontSize: 120,
                        lineHeight: 0.7,
                        marginBottom: 180,
                    },
                    7: {
                        fontSize: 130,
                        lineHeight: 0.7,
                        marginBottom: 200,
                    },
                    8: {
                        fontSize: 125,
                        lineHeight: 0.7,
                        marginBottom: 190,
                    },
                    9: {
                        fontSize: 123,
                        lineHeight: 0.7,
                        marginBottom: 180,
                    },
                    10: {
                        fontSize: 120,
                        lineHeight: 0.7,
                        marginBottom: 180,
                    },
                },
                "Jersey": {
                    1: {
                        fontSize: 94,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    2: {
                        fontSize: 94,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    3: {
                        fontSize: 94,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    4: {
                        fontSize: 92,
                        lineHeight: 1,
                        marginBottom: 84,
                    },
                    5: {
                        fontSize: 92,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    6: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    7: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    8: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    9: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    10: {
                        fontSize: 72,
                        lineHeight: 1,
                        marginBottom: 74,
                    },
                },
                "Jersey 69": {
                    1: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    2: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    3: {
                        fontSize: 94,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    4: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    5: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    6: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    7: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    8: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: 95,
                    },
                    9: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    10: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: 85,
                    },
                },
                "Gloucester MT Extra Condensed": {
                    1: {
                        fontSize: 100,
                        lineHeight: 0.8,
                        marginBottom: 110,
                    },
                    2: {
                        fontSize: 100,
                        lineHeight: 0.8,
                        marginBottom: 110,
                    },
                    3: {
                        fontSize: 100,
                        lineHeight: 0.8,
                        marginBottom: 110,
                    },
                    4: {
                        fontSize: 100,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    5: {
                        fontSize: 98,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    6: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    7: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 115,
                    },
                    8: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    9: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    10: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                },
                Ultramagnetic: {
                    1: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    3: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    4: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    5: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    6: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: 105,
                    },
                    7: {
                        fontSize: 78,
                        lineHeight: 1,
                        marginBottom: 95,
                    },
                    8: {
                        fontSize: 78,
                        lineHeight: 1,
                        marginBottom: 95,
                    },
                    9: {
                        fontSize: 78,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    10: {
                        fontSize: 78,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                },
                Soap: {
                    1: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 115,
                    },
                    2: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    3: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    4: {
                        fontSize: 95,
                        lineHeight: 1,
                        marginBottom: 110,
                    },
                    5: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    6: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: 100,
                    },
                    7: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: 95,
                    },
                    8: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: 90,
                    },
                    9: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: 80,
                    },
                    10: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: 70,
                    },
                },
                "ALAMO OP EDITED": {
                    1: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 110,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 110,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 110,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 110,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 95,
                        marginBottom: 100,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 95,
                        marginBottom: 100,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 93,
                        marginBottom: 98,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 95,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 90,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 80,
                    },
                },
                "Club Sandwich": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Cooprblk": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Double Porter 1": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
            },
        },
        body: {
            label: "Body Color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "kelly green",
                    value: "#105c37",
                },
                // {
                //     key: "cream",
                //     value: "#f1e7b2",
                // },
                // {
                //     key: "sand",
                //     value: "#e4d3b9",
                // },
                {
                    key: "red",
                    value: "#BF1329",
                },
                {
                    key: "navy",
                    value: "#121E39",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "white",
                    value: "#FFFFFF",
                },
                {
                    key: "columbia",
                    value: "#528cb2",
                },
                // {
                //     key: "forest",
                //     value: "#224131",
                // },
                {
                    key: "light purple",
                    value: "#8c689c",
                },
                {
                    key: "orange",
                    value: "#d96000",
                },
            ],
            resolver: (key) => `/customizer/camp-flag/body/${key}.png`,
        },
        bandColor: {
            label: "Border Color",
            options: [{
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#e4d3b9",
                // },
            ],
            resolver: (key) => `/customizer/camp-flag/border/${key}.png`,
        },
        printColor: {
            label: "Print Color",
            options: [{
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#F1DAB2",
                // },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
            ],
            resolver: (key) => {
                switch (key) {
                    case "black":
                        return "#000000";
                    case "cream":
                        return "#f1e7b2";
                    case "sand":
                        return "#F1DAB2";
                    case "white":
                        return "#FFFFFF";
                    case "gold":
                        return "#FB9B00";
                    case "pink":
                        return "#EEB2CA";
                    case "red":
                        return "#BF1329";
                    default:
                        break;
                }
            },
        },
    },
    "5-sided-camp-flag": {
        alignment: {
            padding: "45px 0px 280px 0px",
        },
        text: {
            label: "Custom Text",
            lines: 4,
            maxLength: 10,
            limitReached(text) {
                const lines = text.split("\n");
                return lines.length === this.lines && lines.every((line) => line.length === this.maxLength);
            },
            styles: {
                options: [{
                        key: "Jersey",
                        value: "VARSITY",
                        fontSize: 20,
                        letterSpacing: 1,
                        specialFont: "Jersey Special",
                    },
                    // {
                    //     key: "Jersey 69",
                    //     value: "VARSITY",
                    //     fontSize: 20,
                    //     letterSpacing: 1,
                    // },
                    // {
                    //     key: "Growler Script",
                    //     value: "Script",
                    //     fontSize: 30,
                    //     lineHeight: 0.1,
                    //     paddingBottom: 30,
                    //     bottom: 5,

                    //     // marginBottom: -20,
                    // },
                    // {
                    //     key: "Gloucester MT Extra Condensed",
                    //     value: "CLASSIC",
                    //     fontSize: 35,
                    // },
                    // {
                    //     key: "Ultramagnetic",
                    //     value: "ROUNDED",
                    //     fontSize: 27,
                    // },
                    // {
                    //     key: "Soap",
                    //     value: "BUBBLE",
                    //     fontSize: 18,
                    // },
                    // {
                    //     key: "ALAMO OP EDITED",
                    //     value: "Alamo",
                    //     fontSize: 18,
                    // },
                ],
            },
            scaling: {
                "Growler Script": {
                    1: {
                        fontSize: 170,
                        lineHeight: 0.48,
                        marginBottom: 40,
                    },
                    2: {
                        fontSize: 155,
                        lineHeight: 0.55,
                        marginBottom: 20,
                    },
                    3: {
                        fontSize: 125,
                        lineHeight: 0.62,
                        marginBottom: 0,
                    },
                    4: {
                        fontSize: 110,
                        lineHeight: 0.63,
                        marginBottom: -20,
                    },
                    5: {
                        fontSize: 95,
                        lineHeight: 0.65,
                        marginBottom: -20,
                    },
                    6: {
                        fontSize: 90,
                        lineHeight: 0.68,
                        marginBottom: -20,
                    },
                    7: {
                        fontSize: 85,
                        lineHeight: 0.7,
                        marginBottom: -80,
                    },
                    8: {
                        fontSize: 80,
                        lineHeight: 0.74,
                        marginBottom: -70,
                    },
                    9: {
                        fontSize: 75,
                        lineHeight: 0.76,
                        marginBottom: -70,
                    },
                    10: {
                        fontSize: 75,
                        lineHeight: 0.78,
                        marginBottom: -70,
                    },
                },
                "Jersey": {
                    1: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -110,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -110,
                    },
                    3: {
                        fontSize: 88,
                        lineHeight: 0.9,
                        marginBottom: -110,
                    },
                    4: {
                        fontSize: 78,
                        lineHeight: 0.9,
                        marginBottom: -110,
                    },
                    5: {
                        fontSize: 64,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    6: {
                        fontSize: 64,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    7: {
                        fontSize: 56,
                        lineHeight: 1,
                        marginBottom: -135,
                    },
                    8: {
                        fontSize: 48,
                        lineHeight: 1.2,
                        marginBottom: -140,
                    },
                    9: {
                        fontSize: 40,
                        lineHeight: 1.2,
                        marginBottom: -145,
                    },
                    10: {
                        fontSize: 36,
                        lineHeight: 1.2,
                        marginBottom: -150,
                    },
                },
                "Jersey 69": {
                    1: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 80,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    5: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    6: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    7: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    8: {
                        fontSize: 60,
                        lineHeight: 1.2,
                        marginBottom: -120,
                    },
                    9: {
                        fontSize: 55,
                        lineHeight: 1.2,
                        marginBottom: -130,
                    },
                    10: {
                        fontSize: 52,
                        lineHeight: 1.2,
                        marginBottom: -130,
                    },
                },
                "Gloucester MT Extra Condensed": {
                    1: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    5: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    6: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    7: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    8: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    9: {
                        fontSize: 65,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    10: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                },
                Ultramagnetic: {
                    1: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    5: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    6: {
                        fontSize: 65,
                        lineHeight: 1,
                        marginBottom: -125,
                    },
                    7: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    8: {
                        fontSize: 55,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    9: {
                        fontSize: 50,
                        lineHeight: 1,
                        marginBottom: -140,
                    },
                    10: {
                        fontSize: 50,
                        lineHeight: 1,
                        marginBottom: -140,
                    },
                },
                Soap: {
                    1: {
                        fontSize: 92,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 63,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    4: {
                        fontSize: 62,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    5: {
                        fontSize: 58,
                        lineHeight: 1.2,
                        marginBottom: -140,
                    },
                    6: {
                        fontSize: 52,
                        lineHeight: 1.2,
                        marginBottom: -140,
                    },
                    7: {
                        fontSize: 46,
                        lineHeight: 1.2,
                        marginBottom: -150,
                    },
                    8: {
                        fontSize: 44,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                    9: {
                        fontSize: 42,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                    10: {
                        fontSize: 40,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                },
                "ALAMO OP EDITED": {
                    1: {
                        lineHeight: 0.8,
                        fontSize: 100,
                        marginBottom: -100,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: -100,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: -100,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: -100,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: -100,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: -120,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: -120,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: -130,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 55,
                        marginBottom: -135,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: -140,
                    },
                },
                "Club Sandwich": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Cooprblk": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Double Porter 1": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
            },
        },
        body: {
            label: "Body Color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "kelly green",
                    value: "#105c37",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
                {
                    key: "navy",
                    value: "#121E39",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "white",
                    value: "#FFFFFF",
                },
                // {
                //     key: "cream",
                //     value: "#f1e7b2",
                // },
                // {
                //     key: "sand",
                //     value: "#e4d3b9",
                // },
                // {
                //     key: "forest",
                //     value: "#224131",
                // },
                {
                    key: "columbia",
                    value: "#528cb2",
                },
                {
                    key: "light purple",
                    value: "#8c689c",
                },
                {
                    key: "orange",
                    value: "#d96000",
                },
            ],
            resolver: (key) => `/customizer/5-sided-custom-camp-flag/body/${key}.png`,
        },
        bandColor: {
            label: "Border Color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#e4d3b9",
                // },
            ],
            resolver: (key) => `/customizer/5-sided-custom-camp-flag/border/${key}.png`,
        },
        printColor: {
            label: "Print Color",
            options: [{
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "cream",
                    value: "#f1e7b2",
                },
                // {
                //     key: "sand",
                //     value: "#F1DAB2",
                // },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
            ],
            resolver: (key) => {
                switch (key) {
                    case "black":
                        return "#000000";
                    case "cream":
                        return "#f1e7b2";
                    case "sand":
                        return "#F1DAB2";
                    case "white":
                        return "#FFFFFF";
                    case "gold":
                        return "#FB9B00";
                    case "pink":
                        return "#EEB2CA";
                    case "red":
                        return "#BF1329";
                    default:
                        break;
                }
            },
        },
    },
    "personalized-stitched-sweater-1": {
        alignment: {
            padding: "45px 0px 280px 0px",
        },
        text: {
            label: "Custom Text",
            lines: 2,
            maxLength: 9,
            limitReached(text) {
                const lines = text.split("\n");
                return lines.length === this.lines && lines.every((line) => line.length === this.maxLength);
            },
            styles: {
                options: [{
                        key: "Jersey",
                        value: "VARSITY",
                        fontSize: 20,
                        letterSpacing: 1,
                        specialFont: "Jersey Special",
                    },
                    // {
                    //     key: "Jersey 69",
                    //     value: "VARSITY",
                    //     fontSize: 20,
                    //     letterSpacing: 1,
                    // },
                    // {
                    //     key: "Growler Script",
                    //     value: "Script",
                    //     fontSize: 30,
                    //     lineHeight: 0.1,
                    //     paddingBottom: 30,
                    //     bottom: 5,

                    //     // marginBottom: -20,
                    // },
                    // {
                    //     key: "Gloucester MT Extra Condensed",
                    //     value: "CLASSIC",
                    //     fontSize: 35,
                    // },
                    // {
                    //     key: "Ultramagnetic",
                    //     value: "ROUNDED",
                    //     fontSize: 27,
                    // },
                    // {
                    //     key: "Soap",
                    //     value: "BUBBLE",
                    //     fontSize: 18,
                    // },
                    // {
                    //     key: "ALAMO OP EDITED",
                    //     value: "Alamo",
                    //     fontSize: 18,
                    // },
                ],
            },
            scaling: {
                "Growler Script": {
                    1: {
                        fontSize: 170,
                        lineHeight: 0.48,
                        marginBottom: 40,
                    },
                    2: {
                        fontSize: 155,
                        lineHeight: 0.55,
                        marginBottom: 20,
                    },
                    3: {
                        fontSize: 125,
                        lineHeight: 0.62,
                        marginBottom: 0,
                    },
                    4: {
                        fontSize: 110,
                        lineHeight: 0.63,
                        marginBottom: -20,
                    },
                    5: {
                        fontSize: 95,
                        lineHeight: 0.65,
                        marginBottom: -20,
                    },
                    6: {
                        fontSize: 90,
                        lineHeight: 0.68,
                        marginBottom: -20,
                    },
                    7: {
                        fontSize: 85,
                        lineHeight: 0.7,
                        marginBottom: -80,
                    },
                    8: {
                        fontSize: 80,
                        lineHeight: 0.74,
                        marginBottom: -70,
                    },
                    9: {
                        fontSize: 75,
                        lineHeight: 0.76,
                        marginBottom: -70,
                    },
                    10: {
                        fontSize: 75,
                        lineHeight: 0.78,
                        marginBottom: -70,
                    },
                },
                "Jersey": {
                    1: {
                        fontSize: 36,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    2: {
                        fontSize: 36,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    3: {
                        fontSize: 36,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    4: {
                        fontSize: 36,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    5: {
                        fontSize: 36,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    6: {
                        fontSize: 34,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    7: {
                        fontSize: 34,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    8: {
                        fontSize: 34,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    9: {
                        fontSize: 34,
                        lineHeight: 1,
                        marginBottom: 0,
                    },
                    10: {
                        fontSize: 30,
                        lineHeight: 1,
                        marginBottom: 0,
                    }
                },
                "Jersey 69": {
                    1: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 80,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    5: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    6: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    7: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    8: {
                        fontSize: 60,
                        lineHeight: 1.2,
                        marginBottom: -120,
                    },
                    9: {
                        fontSize: 55,
                        lineHeight: 1.2,
                        marginBottom: -130,
                    },
                    10: {
                        fontSize: 52,
                        lineHeight: 1.2,
                        marginBottom: -130,
                    },
                },
                "Gloucester MT Extra Condensed": {
                    1: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    5: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    6: {
                        fontSize: 85,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    7: {
                        fontSize: 80,
                        lineHeight: 1,
                        marginBottom: -110,
                    },
                    8: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    9: {
                        fontSize: 65,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    10: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                },
                Ultramagnetic: {
                    1: {
                        fontSize: 90,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 88,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 82,
                        lineHeight: 1,
                        marginBottom: -100,
                    },
                    4: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    5: {
                        fontSize: 70,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    6: {
                        fontSize: 65,
                        lineHeight: 1,
                        marginBottom: -125,
                    },
                    7: {
                        fontSize: 60,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    8: {
                        fontSize: 55,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    9: {
                        fontSize: 50,
                        lineHeight: 1,
                        marginBottom: -140,
                    },
                    10: {
                        fontSize: 50,
                        lineHeight: 1,
                        marginBottom: -140,
                    },
                },
                Soap: {
                    1: {
                        fontSize: 92,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    2: {
                        fontSize: 90,
                        lineHeight: 0.9,
                        marginBottom: -100,
                    },
                    3: {
                        fontSize: 63,
                        lineHeight: 1,
                        marginBottom: -120,
                    },
                    4: {
                        fontSize: 62,
                        lineHeight: 1,
                        marginBottom: -130,
                    },
                    5: {
                        fontSize: 58,
                        lineHeight: 1.2,
                        marginBottom: -140,
                    },
                    6: {
                        fontSize: 52,
                        lineHeight: 1.2,
                        marginBottom: -140,
                    },
                    7: {
                        fontSize: 46,
                        lineHeight: 1.2,
                        marginBottom: -150,
                    },
                    8: {
                        fontSize: 44,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                    9: {
                        fontSize: 42,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                    10: {
                        fontSize: 40,
                        lineHeight: 1.2,
                        marginBottom: -160,
                    },
                },
                "ALAMO OP EDITED": {
                    1: {
                        lineHeight: 0.8,
                        fontSize: 100,
                        marginBottom: -100,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: -100,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: -100,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: -100,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: -100,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: -120,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: -120,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 62,
                        marginBottom: -130,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 55,
                        marginBottom: -135,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 52,
                        marginBottom: -140,
                    },
                },
                "Club Sandwich": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Cooprblk": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
                "Double Porter 1": {
                    1: {
                        lineHeight: 1,
                        fontSize: 110,
                        marginBottom: 45,
                    },
                    2: {
                        lineHeight: 1,
                        fontSize: 100,
                        marginBottom: 40,
                    },
                    3: {
                        lineHeight: 1,
                        fontSize: 90,
                        marginBottom: 28,
                    },
                    4: {
                        lineHeight: 1,
                        fontSize: 80,
                        marginBottom: 20,
                    },
                    5: {
                        lineHeight: 1,
                        fontSize: 70,
                        marginBottom: 15,
                    },
                    6: {
                        lineHeight: 1,
                        fontSize: 65,
                        marginBottom: 10,
                    },
                    7: {
                        lineHeight: 1,
                        fontSize: 60,
                        marginBottom: 5,
                    },
                    8: {
                        lineHeight: 1,
                        fontSize: 53,
                        marginBottom: -5,
                    },
                    9: {
                        lineHeight: 1,
                        fontSize: 48,
                        marginBottom: -10,
                    },
                    10: {
                        lineHeight: 1,
                        fontSize: 43,
                        marginBottom: -18,
                    },
                },
            },
        },
        body: {
            label: "sweater color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "stone",
                    value: "#aea697",
                },
                {
                    key: "evergreen",
                    value: "#224131",
                },
                {
                    key: "navy",
                    value: "#121E39",
                },
            ],
            resolver: (key) => `/customizer/5-sided-custom-camp-flag/body/${key}.png`,
        },
        bandColor: {
            label: "letter color",
            options: [
                {
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "sand",
                    value: "#e4d3b9",
                },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
                
            ],
            resolver: (key) => `/customizer/5-sided-custom-camp-flag/border/${key}.png`,
        },
        printColor: {
            label: "Print Color",
            options: [{
                    key: "black",
                    value: "#231F20",
                },
                {
                    key: "sand",
                    value: "#F1DAB2",
                },
                {
                    key: "white",
                    value: "#fff",
                },
                {
                    key: "gold",
                    value: "#FB9B00",
                },
                {
                    key: "pink",
                    value: "#EEB2CA",
                },
                {
                    key: "red",
                    value: "#BF1329",
                },
            ],
            resolver: (key) => {
                switch (key) {
                    case "black":
                        return "#000000";
                    case "sand":
                        return "#F1DAB2";
                    case "white":
                        return "#FFFFFF";
                    case "gold":
                        return "#FB9B00";
                    case "pink":
                        return "#EEB2CA";
                    case "red":
                        return "#BF1329";
                    default:
                        break;
                }
            },
        },
    },
};
class PennantCustomizer extends HTMLElement {
  constructor() {
      super();

      //Product Switcher
      this.dropdownButton = this.querySelector(".c-pennants-header__dropdown-btn");
      this.dropdownContent = this.querySelector(".c-pennants-header__dropdown-content");
      this.selectedProductEl = this.dropdownContent.querySelector(".active");
      this.dropdownButtons = this.querySelectorAll(".c-pennants-header__dropdown-content button");
      this.pennantProductTitle = this.querySelector('[data-product-title] .title');
      this.pennantProductPrice = this.querySelector('[data-product-price]');
      //Customizer Option Tabs
      this.pennantsCustomizerTabs = this.querySelectorAll(".pennants-customizer__tabs button");
      this.tabsPrevButton = this.querySelector(".pennants-customizer__tabs-wrapper .prev");
      this.tabsNextButton = this.querySelector(".pennants-customizer__tabs-wrapper .next");
      this.tabsContent = this.querySelectorAll(".pennants-customizer__tabs-content");

      //Live Preview
      this.productPreview = this.querySelector('.product-preview');
      this.livePreview = this.querySelector("#customizer-main");
      this.livePreviewBackground = this.querySelectorAll(".preview-body-image");
      this.livePreviewBorder = this.querySelectorAll(".preview-band-image");
      this.livePreviewGraphic = this.querySelector("#customizer-graphic");
      this.livePreviewText = this.querySelector("#customizer-text");

      //Customizer Options
      this.pennantCustomizerOptions = this.querySelector(".pennants-customizer");
      this.customizerHeader = this.querySelector('.customizer-header');
      this.bodyColorOptionsContainer = this.querySelector('[data-option="body-colors"]');
      this.borderColorOptionsContainer = this.querySelector('[data-option="border-colors"]');
      this.textColorOptionsContainer = this.querySelector('[data-option="text_color"]');
      this.textStyleOptionsContainer = this.querySelector('[data-option="text_style"]');
      this.graphicOptionsContainer = this.querySelector('[data-option="graphics"]');
      this.textField = this.querySelector("#customizer-text-field");
      this.textFieldLine1 = this.querySelector("#customizer-text-field-line1");
      this.textFieldLine2 = this.querySelector("#customizer-text-field-line2");
      this.checkTypos = this.querySelector("#checked-typos");
      this.ATCButtons = document.querySelectorAll(".quick-add__submit");
      const quantityInput = document.querySelector('input.quantity-input');
      this.plusButton = document.querySelector('.quantity-button.plus');
      this.minusButton = document.querySelector('.quantity-button.minus');
      this.BIS_triggers = document.querySelectorAll('.BIS_trigger');
      this.notifyForms = document.querySelectorAll('.notify-form--wrapper form');       

      this.plusButton.addEventListener('click', function() {
          let currentValue = parseInt(quantityInput.value);
          quantityInput.value = currentValue + 1;
      });

      this.minusButton.addEventListener('click', function() {
          let currentValue = parseInt(quantityInput.value);
          if (currentValue > 1) {
              quantityInput.value = currentValue - 1;
          }
      });

      this.line1 = '';
      this.line2 = '';

      this.textFieldLine1.addEventListener("input", this.updateSweaterText.bind(this));
      this.textFieldLine2.addEventListener("input", this.updateSweaterText2.bind(this));

    
      this.textField.addEventListener("input", this.updateLivePreviewText.bind(this));
      this.checkTypos.addEventListener("change", (e) => {
          this.ATCButtons.forEach(btn => {
                  btn.setAttribute("aria-disabled", !e.target.checked ?? false);
              })
              // this.ATCButton.setAttribute("disabled", !e.target.checked ?? false);
      });
      this.checkAvailability();
      this.setupProductSwitcher();
      this.setupTabSwitcher();
      this.initializeCustomizer();
      this.ATCButtons.forEach(btn => {
          btn.addEventListener("click", async() => {

              if (this.textField.value === '') {
                document.querySelector('.required_fields').style.display = 'block';
                return;
              }
             document.querySelector('.required_fields').style.display = 'none';

              btn.classList.add("loading");
              this.disableOptions();
              let error = null;
              const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
              const product = this.getProduct();

              btn.setAttribute("aria-disabled", true);
              btn.classList.add("loading");
              this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

              try {
                 const previewPNG = await this.convertToPNG();
                
                 async function uploadImage(base64Image) {
                    const apiKey = "9e7b3e5286b02a35643512388a5f77b4"; 
                    const cleanBase64 = base64Image.split(",")[1];
                
                    const formData = new FormData();
                    formData.append("key", apiKey);
                    formData.append("image", cleanBase64);
                
                    try {
                        const response = await fetch("https://api.imgbb.com/1/upload", {
                            method: "POST",
                            body: formData,
                        });
                
                        const result = await response.json();
                        if (result.success) {
                            console.log("Image URL:", result.data.url);
                            return result.data.url;
                        } else {
                            console.error("Upload failed:", result.error.message);
                            return null;
                        }
                    } catch (error) {
                        console.error("Error:", error);
                        return null;
                    }
                }
              
                const uploadedImageUrl = await uploadImage(previewPNG);

                let formData = {
                  id: product[0].id,
                  quantity: quantityInput.value,
                  properties: {}
                };
                
                if (this.configuration.body.label === 'sweater color') {
                  formData.properties = {
                    size: this.querySelector(".sizing_size input:checked").value,
                    sweaterColor: this.bodyColorOptionsContainer.querySelector(":checked").getAttribute("data-name"),
                    letterColor: this.textColorOptionsContainer.querySelector(":checked").getAttribute("data-name"),
                    text1: this.line1,
                    text2: this.line2,
                    __previewPNG: uploadedImageUrl
                  };
                } else {
                  formData.properties = {
                    bodyColor: this.bodyColorOptionsContainer.querySelector(":checked").getAttribute("data-name"),
                    bandColor: this.borderColorOptionsContainer.querySelector(":checked").getAttribute("data-name"),
                    textColor: this.textColorOptionsContainer.querySelector(":checked").getAttribute("data-name"),
                    textStyle: this.textStyleOptionsContainer.querySelector("input").value,
                    text: this.textField.value,
                    __previewPNG: uploadedImageUrl
                  };
}

  
                  if (this.configuration.graphics) {
                      formData.properties.graphic = this.graphicOptionsContainer.querySelector(":checked")?.getAttribute("data-name") ?? "None";
                  }
  
                  if (cart) {
                      formData.sections = cart.getSectionsToRender().map((section) => section.id);
                      formData.sections_url = window.location.pathname;
                      cart.setActiveElement(document.activeElement);
                  }
                
                  const response = await fetch(`${routes.cart_add_url}`, {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                      },
                      body: JSON.stringify(formData),
                  });
                  const json = await response.json();
                  if (json.status) {
                      publish(PUB_SUB_EVENTS.cartError, {
                          source: "product-form",
                          productVariantId: formData.id,
                          errors: json.description,
                          message: json.message,
                      });
                      error = true;
                  } else if (!cart) {
                      window.location = window.routes.cart_url;
                      return;
                  }

                  if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.id });
                  error = false;
                  const quickAddModal = this.closest("quick-add-modal");
                  if (quickAddModal) {
                      document.body.addEventListener(
                          "modalClosed",
                          () => {
                              setTimeout(() => {
                                  cart.renderContents(response);
                              });
                          }, { once: true }
                      );
                      quickAddModal.hide(true);
                  }
                  cart.renderContents(json);
                  quantityInput.value = 1;
              } catch (error) {
                  // console.log(error);
              } finally {
                  btn.classList.remove("loading");
                  if (cart && cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
                  if (!error) btn.removeAttribute("aria-disabled");
                  this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                  this.enableOptions();
              }
              return;
          });
      })
      this.notifyForms.forEach(form => {
          form.addEventListener('submit', (event) => {
              event.preventDefault();
              this.notifyFormSubmit(form);
          })
      })




    this.sweaterSizingInputs = this.querySelectorAll('.pennants-customizer__sweater_sizing input');
    this.dataSelectedSize = this.querySelector('.pennants-customizer__sweater_sizing [data-selected-size]');
     this.sweaterSizingInputs.forEach(input => {
       input.addEventListener('change',(e)=>{
         this.dataSelectedSize.textContent = e.target.value;
       })
     })


    
      return;
  }

  checkAvailability(){
        this.notifyForms.forEach(form => {
            form.closest('.notify-form--wrapper').classList.add('hidden');
        })
        // ... existing code ...
        const selectedTab = Array.from(this.pennantsCustomizerTabs).find(tab => tab.classList.contains('active'));
        const selectedTabIndex = Array.from(this.pennantsCustomizerTabs).indexOf(selectedTab);
        // ... existing code ...
        const product = this.getProduct()[0];
        const handle = this.selectedProductEl.getAttribute("data-for");
        const bisForm = this.querySelector(`[data-form-product="${handle}"]`);
      
        // ... code for personalized-stitched-sweater ... //
        if(bisForm.getAttribute('data-form-product') === 'personalized-stitched-sweater-1'){
           return;
        }
        // ... end code for personalized-stitched-sweater ... //
      
        if (product.available && product.inventory_quantity > 0 ) {
            bisForm.classList.add('hidden');
            this.tabsContent.forEach(content => content.classList.add('hidden'));
            this.tabsContent[selectedTabIndex].classList.remove('hidden');
            this.querySelector('.pennants-customizer__tabs-wrapper').classList.remove('hidden');
        }else {
            bisForm.classList.remove('hidden');
            this.tabsContent.forEach(content => content.classList.add('hidden'));
            this.querySelector('.pennants-customizer__tabs-wrapper').classList.add('hidden');
        }
    }

  updateSweaterText(e) {
    this.livePreview.style.opacity = '1';
    let input = e.target.value;
    let nonSpaceCount = 0;
    let finalValue = '';
  
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
        if (nonSpaceCount >= 9) break;
        nonSpaceCount++;
        finalValue += char;
    }
    e.target.value = finalValue;
    this.line1 = finalValue;
    this.textField.value = `${this.line1}${this.line2 ? '\n' + this.line2 : ''}`;
    this.updateLivePreview();
  }
  
  updateSweaterText2(e) {
    this.livePreview.style.opacity = '1';
    let input = e.target.value;
    let nonSpaceCount = 0;
    let finalValue = '';
  
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
        if (nonSpaceCount >= 9) break;
        nonSpaceCount++;
        finalValue += char;
    }
    e.target.value = finalValue;
    this.line2 = finalValue;
    this.textField.value = `${this.line1}${this.line2 ? '\n' + this.line2 : ''}`;
    this.updateLivePreview();
  }

  initializeCustomizer() {
            const createElementFromString = (htmlString) => {
                const div = document.createElement("div");
                div.innerHTML = htmlString.trim();
                return div.firstChild;
            };

            const createBodyColorOptions = () => {
                const container = this.bodyColorOptionsContainer;
                container.innerHTML = "";
              
                //code for sweater//
                let labels = this.configuration.body.label;
                container.closest('.option-wrapper').querySelector('h2').textContent = labels;
                //end code for sweater//
              
                this.configuration.body.options.forEach((color, index) => {
                    const input = createElementFromString(`<input type="radio" id="body-${color.key}" data-name="${color.key}" name="body-color" value="${color.value}" ${index == 0 && "checked"}>`);
                    const label = createElementFromString(`<label for="body-${color.key}" class="pennants-customizer__checkbox ${index == 0 && "active--white"}" style="background-color:${color.value};"></label>`);
                    container.appendChild(input);
                    container.appendChild(label);
                });
            };

            const createBorderColorOptions = () => {
                const container = this.borderColorOptionsContainer;
                container.innerHTML = "";
              
                //code for sweater//
                let labels = this.configuration.bandColor.label;
                container.closest('.option-wrapper').querySelector('h2').textContent = labels;
                //end code for sweater//
              
                this.configuration.bandColor.options.forEach((color, index) => {
                    const input = createElementFromString(`<input type="radio" id="band-${color.key}" data-name="${color.key}" name="band-ties-color" value="${color.value}" ${index == 0 && "checked"}>`);
                    const label = createElementFromString(`<label for="band-${color.key}" class="pennants-customizer__checkbox ${index == 0 && "active--white"}" style="background-color:${color.value};"></label>`);
                    container.appendChild(input);
                    container.appendChild(label);
                });
            };

            const createTextColorOptions = () => {
                const container = this.textColorOptionsContainer;
                container.innerHTML = "";

                this.configuration.printColor.options.forEach((color, index) => {
                    const input = createElementFromString(`<input type="radio" id="text-${color.key}" data-name="${color.key}" name="text-color" value="${color.value}" ${index == 0 && 'checked tabindex="0"'}>`);
                    const label = createElementFromString(`<label for="text-${color.key}" class="pennants-customizer__checkbox ${index == 0 && "active--white"}" style="background-color:${color.value};" ${index == 0 && 'tabindex="0"'}></label>`);
                    container.appendChild(input);
                    container.appendChild(label);
                });
            };

            const setTextLimits = () => {
                this.textField.setAttribute("value", "");
                this.textField.setAttribute("rows", this.configuration.text.lines);
            };

            const createTextStyleOptions = () => {
                const container = this.textStyleOptionsContainer;
                const optionsList = container.querySelector("ul");
                optionsList.innerHTML = "";

                this.configuration.text.styles.options.forEach((style) => {
                    const option = createElementFromString(`<li class="custom-select__option" data-name="${style.key}" style="font-family:'${style.key}'">${style.value}</li>`);
                    optionsList.appendChild(option);
                });

                const input = container.querySelector("input");
                input.setAttribute("value", optionsList.firstChild.textContent);
                input.style.fontFamily = optionsList.firstChild.getAttribute("data-name");
            };

            const createGraphicOptions = () => {
                    const container = this.graphicOptionsContainer;

                    if (!this.configuration.graphics) {
                        container.parentElement.style.display = "none";
                        return;
                    }
                    container.innerHTML = "";
                    container.parentElement.style.display = "block";

                    this.configuration.graphics.options.forEach((graphic) => {
                                const option = createElementFromString(
                                        `
          <div class="pennants-customizer__graphic">
            <input type="radio" id="graphic-${graphic.key}" data-name="${graphic.value}" name="product-graphic" value="${graphic.value}">
            <label for="graphic-${graphic.key}" class="pennants-customizer__checkbox">
              ${graphic.key && `<img src="${document.imagesCDN}/custom_${this.selectedProductEl.getAttribute("data-for")}_graphic_${graphic.key}.svg" alt="">`}
            </label>
          </div>
          `
        );
        container.appendChild(option);
      });
    };

    const setupColorRadios = () => {
      this.pennantCustomizerOptions.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener("change", (event) => {
          const colorName = event.target.getAttribute("data-name");
          const closestForm = event.target.closest(".option-wrapper");
          const selectedColorSpan = closestForm ? closestForm.querySelector("[data-selected-color]") : null;

          if (selectedColorSpan) {
            selectedColorSpan.innerText = colorName.toUpperCase();
          }

         // Code for sweater //

            let label = this.configuration.body.label;
            let isSweater = label === 'sweater color';
            
            let textFieldLine1 = document.querySelector('.customizer-text-field-line1');
            let textFieldLine2 = document.querySelector('.customizer-text-field-line2');
            let designRow = document.querySelector('[data-name="design"] .pennants-customizer__row');
            let designRowSweaterSizing = document.querySelector('[data-name="design"] .pennants-customizer__sweater_sizing');
            let tabButtons = document.querySelectorAll('.pennants-customizer__tabs button');
            let sweater_des = document.querySelectorAll('.pennants-customizer__tabs-content-sweater_des');
            let other_des = document.querySelectorAll('.pennants-customizer__tabs-content_des');
            let dynamictext = document.querySelectorAll('.dynamictext');
            
            // Update tab labels
            const setTabLabels = (labels = []) => {
              tabButtons.forEach((tabButton, index) => {
                if (labels[index]) {
                  tabButton.textContent = labels[index];
                }
              });
            };
            
            if (isSweater) {
              if (radio.getAttribute('name') === 'band-ties-color') {
                document.querySelector(`label[for="text-${colorName}"]`)?.click();
              }
            
              textFieldLine1.style.display = 'block';
              textFieldLine2.style.display = 'block';
              designRow.style.display = 'none';
              designRowSweaterSizing.style.display = 'block';
              sweater_des.forEach(des => des.style.display = 'block');
              other_des.forEach(des => des.style.display = 'none');
              setTabLabels(['DESIGN', 'SIZING']);
              dynamictext.forEach(des => des.textContent = 'sweater');
              
            } else {
              textFieldLine1.style.display = 'none';
              textFieldLine2.style.display = 'none';
              designRow.style.display = 'flex';
              designRowSweaterSizing.style.display = 'none';
              sweater_des.forEach(des => des.style.display = 'none');
              other_des.forEach(des => des.style.display = 'block');
              setTabLabels(['COLOR', 'DESIGN']);
              dynamictext.forEach(des => des.textContent = 'flag');
            }
            
            // End code for sweater //

          
          this.updateLivePreview();
        });

        if (radio.checked) {
          radio.dispatchEvent(new Event("change"));
        }
      });
    };

    const setupCustomDropdowns = () => {
      const closeOptionDropdowns = () => {
        customDropdowns.forEach((customDropdown) => {
          if (customDropdown.classList.contains("opened")) {
            customDropdown.classList.remove("opened");
          }
        });
      };

      const toggleOptionDropdown = (event) => {
        event.stopPropagation();
        const customDropdown = event.currentTarget;
        customDropdown.classList.toggle("opened");
      };

      const selectOption = (event) => {
        const customDropdown = event.currentTarget.closest(".custom-select");
        const customDropdownInput = customDropdown.querySelector("input");
        customDropdownInput.setAttribute("value", event.currentTarget.textContent);

        if (customDropdown.getAttribute("data-option") == "text_style") {
          this.querySelector("[data-selected-text-style]").textContent = event.currentTarget.textContent;
        }

        this.updateLivePreview();

        console.log(event.currentTarget.getAttribute("data-name"));
        customDropdown.querySelector("input").style.fontFamily = `'${event.currentTarget.getAttribute("data-name")}'`;
      };

      const customDropdowns = this.querySelectorAll(".custom-select");
      if (customDropdowns) {
        customDropdowns.forEach((customDropdown) => {
          customDropdown.onclick = toggleOptionDropdown;
          const listOfOptions = customDropdown.querySelectorAll(".custom-select__option");
          listOfOptions.forEach((option) => option.addEventListener("click", selectOption));
          // customDropdown.addEventListener('click', toggleOptionDropdown);
        });

        //Remove previous click listener, if any
        document.body.removeEventListener("click", closeOptionDropdowns);

        document.body.addEventListener("click", closeOptionDropdowns);
      }
    };

    const resetLivePreview = () => {
      //Reset images
      // this.livePreviewBackground.setAttribute("src", "");
      this.livePreviewBackground.forEach(body => {
        body.classList.add('hidden')
      })
      // this.livePreviewBorder.setAttribute("src", "");
      this.livePreviewBorder.forEach(border => {
        border.classList.add('hidden');
      })

      this.livePreviewGraphic.style.display = "none";

      this.livePreviewText.textContent = "";
    };

    const updateLimitsText = () => {
      this.querySelector("#text-limit").textContent = `${this.configuration.text.maxLength} characters, ${this.configuration.text.lines} line${this.configuration.text.lines > 1 ? "s" : ""} maximum`;
    };

    const setupImageLoaders = () => {
      // this.livePreviewBackground.onload = () => this.enableOptions();
      this.livePreviewBackground.forEach(body => {
        body.onload = () => this.enableOptions();
      })

      // this.livePreviewBorder.onload = () => this.enableOptions();
      this.livePreviewBorder.forEach(border => {
        border.onload = () => this.enableOptions();
      })
    };

    const setProductName = () => {
      this.pennantProductTitle.textContent = this.selectedProductEl.dataset.title;
    }

    const setProductPrice = () => {
      this.pennantProductPrice.textContent = Shopify.formatMoney(this.selectedProductEl.dataset.price);
    }

    const productName = this.selectedProductEl.getAttribute("data-for").toLowerCase();
    this.configuration = CustomProductsConfigurations[productName];

    resetLivePreview();

    createBodyColorOptions();
    createBorderColorOptions();
    createTextColorOptions();
    createTextStyleOptions();
    createGraphicOptions();
    setTextLimits();
    updateLimitsText();

    // Click Listeners
    setupColorRadios();
    setupCustomDropdowns();
    setupImageLoaders();
    setProductName();
    setProductPrice();

    //Update front-end after initialization
    this.updateLivePreview();
    this.updatePrice();
    this.updateDimension();
  }

  setupProductSwitcher() {
    const showDropdownContent = () => {
    setTimeout(()=>{
      this.dropdownContent.classList.toggle("show");
      this.dropdownButton.classList.toggle("rotate");
    })
    };

    const hideDropdownContent = (event) => {
      if (!this.dropdownButton.contains(event.target) && !this.dropdownContent.contains(event.target)) {
        this.dropdownContent.classList.remove("show");
        this.dropdownButton.classList.remove("rotate");
      }
    };

    const dropdownContentButtonListener = (event) => {
      event.stopPropagation();
      this.dropdownButtons.forEach((btn) => {
        btn.classList.remove("active");
      });
      event.target.classList.add("active");

      this.selectedProductEl = event.target;
    //   this.setupTabSwitcher();
      this.checkAvailability();
      this.initializeCustomizer();

      this.dropdownContent.classList.remove("show");
      this.dropdownButton.classList.remove("rotate");

      this.textFieldLine1.value = '';
      this.textFieldLine2.value = '';
      this.line1 = '';
      this.line2 = '';
      
      if (this.configuration.body.label === 'sweater color') {
        this.livePreview.style.opacity = '0';
      } else {
        this.livePreview.style.opacity = '1'; 
      }
      
      this.updateLivePreview();
    };

    if (this.dropdownButton && this.dropdownContent && this.dropdownButtons) {
      this.dropdownButton.addEventListener("click", showDropdownContent.bind(this));
      document.addEventListener("click", hideDropdownContent.bind(this));
    }

    this.dropdownButtons.forEach((button) => button.addEventListener("click", dropdownContentButtonListener.bind(this)));
  }

  setupTabSwitcher() {
    console.log('tab switch setup function called');
    const switchTab = (button, index) => {
      this.pennantsCustomizerTabs.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      this.tabsContent.forEach((content) => content.classList.add("hidden"));
      this.tabsContent[index].classList.remove("hidden");
    };

    // switchTab(this.pennantsCustomizerTabs[0], 0);

    if (this.pennantsCustomizerTabs && this.tabsPrevButton && this.tabsNextButton && this.tabsContent) {
      this.pennantsCustomizerTabs.forEach((tab, index) => {
        const windowSize = window.innerWidth;
        tab.addEventListener("click", () => {
          if (windowSize < 749) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
          if (index == (this.pennantsCustomizerTabs.length - 1)) {
            this.customizerHeader.classList.add('hidden')
          }else {
            this.customizerHeader.classList.remove('hidden')
          }

          this.ATCButtons.forEach(btn => {
            if (windowSize < 749) {
              console.log(index,this.pennantsCustomizerTabs.length - 1)
              if (index == (this.pennantsCustomizerTabs.length - 1)) {
                if (btn.closest('.pennant-ATC--mobile')) {
                  btn.closest('.pennant-ATC--mobile').classList.remove('visually-hidden');
                }
              }else {
                if (btn.closest('.pennant-ATC--mobile')) {
                  btn.closest('.pennant-ATC--mobile').classList.add('visually-hidden');
                }
              }
            }
          })
          
          switchTab(tab, index)

        });
      });

      this.tabsPrevButton.addEventListener("click", () => {
        const tabsActiveButton = this.productPreview.querySelector(".pennants-customizer__tabs button.active");
        const tabsWrapper = this.productPreview.querySelector(".pennants-customizer__tabs");
        const tabButtons = Array.prototype.slice.call( tabsWrapper.children );
        let tabsPrevButton = tabsActiveButton.previousElementSibling;
        console.log(tabsPrevButton);
        const windowSize = window.innerWidth;

        // Find the closest previous sibling that is NOT hidden (display: none)
        while (tabsPrevButton && window.getComputedStyle(tabsPrevButton).display === "none") {
            tabsPrevButton = tabsPrevButton.previousElementSibling;
        }

        
        if (windowSize < 749) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        if (tabsPrevButton !== null) {
          this.customizerHeader.classList.remove("hidden");
          this.ATCButtons.forEach(btn => {
            if (windowSize < 749) {
              if (btn.closest('.pennant-ATC--mobile')) {
                btn.closest('.pennant-ATC--mobile').classList.add('visually-hidden');
              }
            }
          })
          tabsActiveButton.classList.remove("active");
          tabsPrevButton.classList.add("active");

          const prevTabIndex = Array.from(this.pennantsCustomizerTabs).indexOf(tabsPrevButton);
          console.log("this.tabsContent:",this.tabsContent);
          this.tabsContent.forEach((content) => content.classList.add("hidden"));
          this.tabsContent[prevTabIndex].classList.remove("hidden");
        }
      });
      this.tabsNextButton.addEventListener("click", () => {
        const tabsActiveButton = this.productPreview.querySelector(".pennants-customizer__tabs button.active");
        const tabsWrapper = this.productPreview.querySelector(".pennants-customizer__tabs");
        const tabButtons = Array.prototype.slice.call( tabsWrapper.children );
        let tabsNextButton = tabsActiveButton.nextElementSibling;
        //console.log(tabsActiveButton);
        const windowSize = window.innerWidth;

        // Find the closest next sibling that is NOT hidden (display: none)
        while (tabsNextButton && window.getComputedStyle(tabsNextButton).display === "none") {
            tabsNextButton = tabsNextButton.nextElementSibling;
        }
        
        if (windowSize < 749) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        if ((tabButtons.indexOf(tabsActiveButton) + 2) == tabButtons.length) {
          this.customizerHeader.classList.add("hidden");
          this.ATCButtons.forEach(btn => {
            if (windowSize < 749) {
              if (btn.closest('.pennant-ATC--mobile')) {
                btn.closest('.pennant-ATC--mobile').classList.remove('visually-hidden');
              }
            }
          })
        }
        if (tabsNextButton == null) return;
        // if (tabsNextButton !== null) {
          tabsActiveButton.classList.remove("active");
          tabsNextButton.classList.add("active");

          const nextTabIndex = Array.from(this.pennantsCustomizerTabs).indexOf(tabsNextButton);


          this.tabsContent.forEach((content) => content.classList.add("hidden"));
          this.tabsContent[nextTabIndex].classList.remove("hidden");
        // }

      });
    }
  }

  disableOptions() {
    this.querySelectorAll("input,button,.custom-select").forEach((el) => {
      el.classList.add("disabled");
    });
  }

  enableOptions() {
    this.querySelectorAll("input,button,.custom-select").forEach((el) => {
      el.classList.remove("disabled");
    });
  }

  updateLivePreviewImages(option, productName) {
    const name = option.getAttribute("id");
    const [property, key] = name.split("-");
    const fileName = `${productName}_${property}_${key.replace(' ', '-')}`;
    switch (property) {
      case "body":
        if (!document.querySelector(`[data-name="${fileName}"]`).classList.contains('hidden')) break;
        this.disableOptions();
        // this.livePreviewBackground.setAttribute("href", fileName);
        this.livePreviewBackground.forEach(body => {
          body.classList.add('hidden')
        })
        document.querySelector(`[data-name="${fileName}"]`).classList.remove('hidden');
        this.enableOptions();
        break;
      case "band":
        if (!document.querySelector(`[data-name="${fileName}"]`)?.classList.contains('hidden')) break;
        this.disableOptions();
        // this.livePreviewBorder.setAttribute("href", fileName);
        this.livePreviewBorder.forEach(body => {
          body.classList.add('hidden')
        })
        document.querySelector(`[data-name="${fileName}"]`)?.classList.remove('hidden');
        this.enableOptions();
        break;
      case "graphic":
        if (key.length == 0 || !this.configuration.graphics) {
          this.livePreviewGraphic.classList.remove("show");
          return;
        }
        const graphic = this.configuration.graphics.options.find((opt) => opt.key == key);
        this.livePreviewGraphic.classList.add("show");
        this.livePreviewGraphic.classList.toggle("shrink", graphic?.shrink ?? false);
        // console.log(graphic);
        const url = `${document.imagesCDN}/custom_${productName}_${property}_${key}.svg`;
        this.livePreviewGraphic.setAttribute("data-src", url);
        break;
      default:
        break;
    }
  }

  updateLivePreview() {
    if (!this.selectedProductEl) return;
    const productName = this.selectedProductEl.getAttribute("data-for").toLowerCase();
    this.pennantCustomizerOptions.setAttribute('selected-product', this.selectedProductEl.getAttribute("data-for"));
    const selectedRadioOptions = this.pennantCustomizerOptions.querySelectorAll(":checked");
    selectedRadioOptions.forEach((option) => this.updateLivePreviewImages(option, productName));
    this.updateLivePreviewText();
  }

  updateLivePreviewText() {
    const getScalingInformation = () => {
      
      var invalidChars = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2B50}-\u{2B55}\u{231A}-\u{23FA}]|(:-?[)D])/gu;
    
      if (invalidChars.test(text)) {
          // Remove invalid characters
          text = text.replace(invalidChars, '');
          this.textField.value = text;
      }
      const lines = text.split("\n");
      let longestLineLength = 0;
      lines.forEach((line) => {
        if (line.length > longestLineLength) longestLineLength = line.length;
      });
      return this.configuration.text.scaling?.[textStyle.key][longestLineLength] ?? {};
    };

    const styleToString = (style) => {
      return Object.keys(style).reduce(
        (acc, key) =>
          acc +
          key
            .split(/(?=[A-Z])/)
            .join("-")
            .toLowerCase() +
          ":" +
          style[key] +
          ";",
        ""
      );
    };

    const convertValuesToString = (style) => {
      let newStyle = {};
      for (const key of Object.keys(style)) {
        if (key != "lineHeight" && typeof style[key] == "number") {
          newStyle[key] = `${style[key]}px`;
        } else {
          newStyle[key] = style[key];
        }
      }
      return newStyle;
    };

    const getSelectedTextStyle = () => {
      // console.log('in getSelectedTextStyle function' );
      const inputValue = this.textStyleOptionsContainer.querySelector("input").getAttribute("value").toLowerCase();
      const key = Array.from(this.textStyleOptionsContainer.querySelectorAll("li"))
        .find((el) => el.textContent.toLowerCase() == inputValue)
        .getAttribute("data-name");
      return this.configuration.text.styles.options.find((opt) => opt.key == key);
    };

    const formatInput = (text) => {
      const maxLength = this.configuration.text.maxLength;
      const maxLines = this.configuration.text.lines;
      let lines = text.split("\n");
      if (lines.length <= maxLines && lines.every((line) => line.length <= maxLength)) {
        return text;
      } else if (lines.length < maxLines) {
        const extendedLineIndex = lines.findIndex((line) => line.length > maxLength);
        if (extendedLineIndex === -1) return;
        const extendedLine = lines[extendedLineIndex];
        const lastSpaceIndex = extendedLine.lastIndexOf(" ");
        if (lastSpaceIndex >= 0) {
          const lastWord = extendedLine.substring(lastSpaceIndex + 1);
          const newLine = extendedLine.substring(0, lastSpaceIndex) + "\n" + lastWord;
          lines[extendedLineIndex] = newLine;
        } else {
          const newLine = extendedLine.substring(0, maxLength) + "\n" + extendedLine.substring(maxLength);
          lines[extendedLineIndex] = newLine;
        }

        return lines.join("\n");
      } else {
        lines = lines.slice(0, maxLines);
        for (let i = 0; i < lines.length; i++) {
          if (lines[i].length > maxLength) lines[i] = lines[i].substring(0, maxLength);
        }
        return lines.join("\n");
      }
    };

    var text = formatInput(this.textField.value);
    this.textField.value = text;
    const textColor = this.textColorOptionsContainer.querySelector(":checked").getAttribute("data-name");
    const productName = this.selectedProductEl.getAttribute("data-for").toLowerCase();
    const textStyle = getSelectedTextStyle();
    let style = {
      fontFamily: `'${textStyle.key}'`,
      fontSize: textStyle.fontSize,
      lineHeight: textStyle.lineHeight,
      '--special-font': `'${textStyle.specialFont}'`,
      ...getScalingInformation(),
    };

    const designIconPresent = this.graphicOptionsContainer.classList.contains("show");
    if (!designIconPresent && productName == "pennant") {
      style.fontSize *= textStyle.noDesignIcon.textScaling;
      if (style.marginBottom > 0) style.marginBottom *= textStyle.noDesignIcon.marginScaling;
    }

    this.livePreview.classList.toggle("justify-center", !designIconPresent && productName != "pennant");


    style = convertValuesToString(style);


    this.livePreviewText.parentElement.style.padding = this.configuration.alignment?.padding ?? "50px";
    this.livePreviewText.style.cssText = styleToString(style);
    // Split text into characters and wrap special characters in spans


    if(this.configuration.body.label == 'sweater color'){
      const lines = text.split('\n').map((line) => {
      let specialChars = '';
      return line.split('').reduce((result, char, index, array) => {
        if (!/^[a-zA-Z0-9\s]$/.test(char)) {
          specialChars += char;
          if (index === array.length - 1 || /^[a-zA-Z0-9\s]$/.test(array[index + 1])) {
            result.push(`${specialChars}`);
            specialChars = '';
          }
        } else {
          result.push(char);
        }
        return result;
      }, []).join('');
    });
     const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

    const viewBoxValue = isFirefox ? '0 55 300 5' : '0 -30 300 5';
    const arcPath = isFirefox ? 'M 50 60 A 100 70 0 0 1 250 60' : 'M 50 50 A 100 100 0 0 1 250 50';
    const textLengthValue = isFirefox
      ? lines[0].length > 7 ? '200' : '150'
      : 'auto';

    const textLengthAttr = isFirefox ? `textLength="${textLengthValue}"` : '';
    
    lines[0] = `<span id="firstline">
      <svg width="300" height="5" viewBox="${viewBoxValue}" xmlns="http://www.w3.org/2000/svg" style="overflow: visible;">
        <defs>
          <path id="archPath" d="${arcPath}" fill="none" />
        </defs>
        <text fill="${this.configuration.printColor.resolver(textColor)}" ${textLengthAttr} lengthAdjust="spacing">
          <textPath href="#archPath" startOffset="50%" text-anchor="middle">
            ${lines[0]}
          </textPath>
        </text>
      </svg>
    </span>`;


      text = lines.join('<br>');
    }else{
      let specialChars = '';
      text = text.split('').reduce((result, char, index, array) => {
      // Check if character is not alphanumeric using regex
      if (!/^[a-zA-Z0-9\s]$/.test(char)) {
        specialChars += char;
        // If next char is not special or this is the last char, output accumulated special chars
        if (index === array.length - 1 || /^[a-zA-Z0-9\s]$/.test(array[index + 1])) {
          result.push(`<span class="special-character">${specialChars}</span>`);
          specialChars = '';
        }
      } else {
        result.push(char);
      }
      return result;
    }, []).join('');
    }


    this.livePreviewText.innerHTML = text;
    

      if(this.configuration.body.label == 'sweater color'){
          if(this.line2 == ''){
            if(navigator.userAgent.toLowerCase().includes('firefox')){
               this.livePreviewText.style.marginBottom = '-20px';
            }else{
               this.livePreviewText.style.marginBottom = '5px';
            }
          }else{
            if(navigator.userAgent.toLowerCase().includes('firefox')){
              this.livePreviewText.style.marginBottom = '-85px';
            }else{
              this.livePreviewText.style.marginBottom = '-65px';              
            }
          }
      }
    

    //Update main customizer container color
    this.livePreview.style.color = this.configuration.printColor.resolver(textColor);
  }

  updatePrice() {
    const product = this.getProduct();
    document.querySelectorAll(".price").forEach(elem => {elem.textContent = product[0].price / 100;})
  }

  getProduct() {
    const handle = this.selectedProductEl.getAttribute("data-for");
    return JSON.parse(document.getElementById(handle).textContent);
  }

  updateDimension() {
    const currentProductDimensionsVal = this.selectedProductEl.getAttribute('data-dimension').split(":");
    const currentDimensions = currentProductDimensionsVal[currentProductDimensionsVal.length - 1].trim();

    document.getElementById('pennant_dimentions').textContent = currentDimensions;
  }
  
  notifyFormSubmit(form) {
    const formData = (new FormData(form));
    let email = formData.get('email');
    let productId = formData.get('productId');
    let variantId = formData.get('variantId');
    let errorEl = this.querySelector('[data-error-msg]');
    BIS.create(email, variantId, productId)
    .then(function(resp){
        if (resp.status == 'OK') {
            form.closest('.notify-form--wrapper').classList.add('hidden');
            errorEl.classList.remove('hidden');
            errorEl.classList.add('success');
            errorEl.innerText = resp.message;
            setTimeout(() => {
                errorEl.classList.add('hidden');
                form.closest('.notify-form--wrapper').classList.remove('hidden');
                errorEl.classList.remove('success');
                form.reset();
            }, 5000);
        } else {
            form.closest('.notify-form--wrapper').classList.add('hidden');
            errorEl.classList.remove('hidden');
            errorEl.classList.add('error');
            errorEl.innerText = resp.errors.base[0];
            setTimeout(() => {
                errorEl.classList.add('hidden');
                form.closest('.notify-form--wrapper').classList.remove('hidden');
                errorEl.classList.remove('error');
                form.reset();
            }, 2000);
        }
    })
  }


  async convertToPNG() {
    async function convertImagesToBase64(svgElement) {
      const images = svgElement.querySelectorAll("image");

      const promises = Array.from(images).map(async (img) => {
        const href = img.getAttribute("href") || img.getAttribute("xlink:href");
        if (!href || href.startsWith("data:image")) return; // Skip if already in Base64

        try {
            const response = await fetch(href, { mode: "cors" });
            if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);
            const blob = await response.blob();
            const reader = new FileReader();

            return new Promise((resolve) => {
                reader.onloadend = function () {
                    img.setAttribute("href", reader.result);
                    resolve();
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.warn("Failed to fetch image:", href, error);
        }
    });

      await Promise.all(promises);
    }

    function copyAllComputedStyles(rootElement) {
    function copyStyles(element) {
        const computedStyle = window.getComputedStyle(element);
        for (let i = 0; i < computedStyle.length; i++) {
            const prop = computedStyle[i];
            element.style[prop] = computedStyle.getPropertyValue(prop);
        }
    }

    // Apply styles to all div elements inside the SVG
    rootElement.querySelectorAll("div").forEach((div) => {
        copyStyles(div);
        div.style.padding = window.getComputedStyle(div).padding; // Ensure padding is copied

        console.log(div)
    });
}

    function fixParagraphStyles(svgElement) {
    const paragraphs = svgElement.querySelectorAll("p");
    paragraphs.forEach((p) => {
        const computedStyle = window.getComputedStyle(p);

        // Ensure critical text styles
        p.style.textAlign = "center";
        p.style.whiteSpace = "pre-line";
        p.style.color = computedStyle.color; // Maintain text color

        // Apply positioning styles
        p.style.position = computedStyle.position;
        p.style.top = computedStyle.top;
        p.style.bottom = computedStyle.bottom;
        p.style.left = computedStyle.left;
        p.style.right = computedStyle.right;
        p.style.transform = computedStyle.transform; // Include transform if needed

   //     p.style.marginLeft = '-40%';
   //     p.style.marginTop = '20%'
      //  console.log("Copied styles for <p>:", p.style);
    });
}

    const svgElement = this.querySelector(".c-pennants-header > svg");
    if (!svgElement) {
        console.error("SVG element not found!");
        return;
    }

    // Convert all external images to Base64
    await convertImagesToBase64(svgElement);

    
    // Fix paragraph styling explicitly
    fixParagraphStyles(svgElement);


    const dataUrl = await domtoimage.toPng(svgElement, {left: 0, right: 0, bottom: 0, top: 0});


    return dataUrl;    
  }
}

if (!customElements.get("pennant-customizer")) {
  customElements.define("pennant-customizer", PennantCustomizer);
}